import { Helmet } from 'react-helmet';
import logo from './logo.png';
import splash from './splash_image.jpg';
import mainScreen from './main_screen.png';
import history from './history.png';
import './App.css';

const topUrl = 'https://www.ryujincomputing.co.jp/';

function RcVidPlayerLight(ver, privacyPolicy) {
  switch (ver) {
    case "1.0.0":
    case "1.1.0":
    case "1.1.1":
    case "1.2.0":
    case "1.3.0":
    case "1.4.0":
    case "1.5.0":
      if (privacyPolicy === null) {
        return body(ver);
      }
      return privacyPolicyPage(ver);

    default:
      return noVer();
  }
}

const noVer = () => {
  return <div className="App">
          <header className="App-header">
            <img src={logo} className="App-logo" alt="logo" />
            <p>RcVidPlayerLight</p>
          </header>
          <p className="p-indent">
            未知のバージョン指定です。URLパラメータをご確認ください。
          </p>
        </div>;
}

const linkToTop = () => {
  return <a href={topUrl}>龍神コンピューティングのトップページへ</a>;
}

const privacyPolicyPage = (ver) => {
  var appName = ver == "1.0.0" ? "RcVidPlayerLight" : "再生名人"

  return <>
          <Helmet>
            <title>{appName}</title>
          </Helmet>
          <div className="App">
            <header className="App-header">
              <img src={logo} className="App-logo" alt="logo" />
              <p>{appName}({ver})</p>
            </header>
            { showPrivacyPolicy(ver)}
            { linkToTop() }
          </div>
        </>;
}

const body = (ver) => {
    var appName = ver == "1.0.0" ? "RcVidPlayerLight" : "再生名人"
    var exoPlayerVersion = ver == "1.0.0" ? "1.7.1" : "1.8.0"
    if (ver == "1.4.0"){
      exoPlayerVersion = "1.9.1"
    }

    return (
      <div className="App">
        <Helmet>
          <title>{appName}</title>
        </Helmet>
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <p>{appName}({ver})</p>
        </header>
        <div className='usage'>
          <h1 className='h-margin'>概要・使い方</h1>
          <p className="p-indent">
            このアプリはデバイス内に保存されている動画ファイルを再生するソフトウェアです。楽しい気分になれるよう、ポップアートとともにお届けします。androidのmedia3-ExoPlayer({exoPlayerVersion})を利用しているので、対応動画ファイルフォーマットはそちらの説明を参照してください。
          </p>
          <p className="p-indent">
            アプリを起動するとスプラッシュ画面が表示された後メイン画面になり、自動的にファイル選択画面または再生履歴画面へ遷移します。動画ファイルはデータ容量が大きいためデバイスのメモリーを圧迫します。確認して不要なものと判明したものは削除してデバイスの空き容量を確保しましょう。
          </p>
          <figure>
            <img src={splash} className="splash" alt="splash" />
            <figcaption>スプラッシュ画像</figcaption>
          </figure>

          <h2 className='h-margin'>【メイン画面】</h2>
          <figure>
            <img src={mainScreen} className="back" alt="back" />
            <figcaption>メイン画面</figcaption>
          </figure>
          <p className="p-indent">
            「ウェブページを開く」ボタンを押すとブラウザで当ページを開きます。
          </p>
          <p className="p-indent">
            メイン画面は自動的に再生履歴画面へ遷移するので、その後「ウェブページを開く」ボタンを押したい場合はOSの戻るボタンでメイン画面へ戻ってください。
          </p>

          <p className="p-indent">
            再生履歴がある場合は再生履歴画面へ遷移し、ない場合はファイル選択画面へ遷移します。
          </p>
          <p className="p-indent">
            ファイル選択画面はandroidのシステムが提供しているものですので、そちらの使い方を参照してください。
          </p>
          <p className="p-indent">
            履歴項目またはファイルを選択すると再生画面へ遷移し、再生が始まります。
          </p>

          <h2 className='h-margin'>【再生画面】</h2>
          <p className="p-indent">
            デバイスの回転に対応していますので見やすい向きで視聴してください。
          </p>
          <p className="p-indent">
            再生中に画面をタッチすると下部に「一時停止」「停止」ボタンとシークバーが表示されます。
          </p>
          <p className="p-indent">
            操作せずに数秒経過するとこれらボタン類は非表示になります（タッチするとまた表示されます）。
          </p>
          <p className="p-indent">
            シークバーをドラッグすると進捗の%表示が変化するので再生したい%位置でドラッグを終えてください。その位置から再生が再開されます。
          </p>
          <p className="p-indent">
            「一時停止」ボタンを押すと再生が一時停止します。再度同じボタンを押すと再生が再開します。
          </p>
          <p className="p-indent">
            「停止」ボタンまたはOSの「戻る」ボタンを押すと再生が中断し、履歴画面へ遷移します。
          </p>
          <h2 className='h-margin'>【再生履歴画面】</h2>
          <p className="p-indent">
            再生履歴を10件まで表示します。10件を超えた分は古いものから消えていきます。
          </p>
          <figure>
            <img src={history} className="history" alt="再生履歴画面" />
            <figcaption>再生履歴画面</figcaption>
          </figure>
          <p className='historyContents'>
            表示内容は
            <ul>
              <li>ファイル表示名</li>
              <li>再生進捗%（0～100%）</li>
              <li>再生を終わった日時（日本時間）</li>
              <li>状態</li>
            </ul>
            { stateInstructions(ver) }
          </p>
          <p className="p-indent">
            履歴の項目（行）をタップすると該当ファイルが中断位置から再生されます。進捗が100%となっている場合は該当ファイルを最初から再生します。0%以上進捗しているけどErrとなっている場合は該当ファイルを最初から再生します。
          </p>
          <p className="p-indent">
            履歴の項目（行）はスワイプして削除することができます。
          </p>
          <p className="p-indent">
            最後に再生したファイルの情報が履歴の一番上に表示されます。
          </p>
          <p className="p-indent">
            下部にファイル選択画面へ遷移するボタンがありますので、新たにファイル選択をしたい場合はクリックしてください。
          </p>
        </div>
        <div className='playstore'>
          <h1 className='h-margin'>Play&nbsp;Store&nbsp;ページ</h1>
          <p className="p-indent">
            <a href="https://play.google.com/store/apps/details?id=jp.co.ryujincomputing.rcvidplayerlight">こちらからダウンロード・インストールしてください。</a>
          </p>
        </div>
        <div className='disclaimer'>
          <h1 className='h-margin'>免責事項</h1>
          <p className="p-indent">
            このアプリはファイルの更新や削除は行いませんが、再生履歴をデバイス内に保存します。アプリの使用によりデバイスに損傷が生じたり、何らかの被害が発生しても弊社では責任を負えませんのでご了承ください。
          </p>
          <p className="p-indent">
            動画ファイルを指定しているにもかかわらず正常に再生されない場合もあり得ますが個別に対応することはできませんのでご了承ください。
          </p>
        </div>
        { showPrivacyPolicy() }
        { linkToTop() }
        { showBuildHistory(ver) }
        { linkToTop() }
      </div>
    );
}

const stateInstructions = ver => {
  switch (ver) {
    case "1.0.0":
    case "1.1.0":
      return "※状態のところには、ブランク、「Fin」「Err」の表示が出ます。ブランクは再生途中になっていることを表します。Finは再生完了したことがあることを表します。Errは進捗%のところでエラー停止したことを表します。再生できないファイルを指定すると0%でErrとなります。";
    default:  // 1.1.1 以降
      return "※状態のところには、ブランク、「Fin」「Err」「Del」の表示が出ます。ブランクは再生途中になっていることを表します。Finは再生完了したことがあることを表します。Errは進捗%のところでエラー停止したことを表します。再生できないファイルを指定すると0%でErrとなります。Delは対象ファイルが見当たらないことを表します。";
  }
}

const showBuildHistory = ver => {
  if (ver === '1.0.0' || ver === '1.1.0') {
    return null;
  }

  return <>
      <div className='buildHistory'>
        <h1 className='h-margin'>バージョンと修正等内容</h1>
        <p className="p-indent">
          version 1.5.0
        </p>
        <p className="p-indent">
          ベースライブラリを更新しました。コンテンツ再生中にデバイスがスリープしないようにしました。
        </p>
        <p className="p-indent">
          version 1.4.0
        </p>
        <p className="p-indent">
          EdgeToEdge 対応を更新しました。再生画面のナビゲーションバーの背景を透明にし、コンテンツの視認性を向上しました。
        </p>
        <p className="p-indent">
          version 1.3.0
        </p>
        <p className="p-indent">
          EdgeToEdge 対応を更新しました。ほとんどのユーザーにおいて画面表示領域いっぱいいっぱいにコンテンツが表示されるようになります。
        </p>
        <p className="p-indent">
          version 1.2.0
        </p>
        <p className="p-indent">
          EdgeToEdge 対応不足を処置しました。ほとんどのユーザーにおいて画面表示領域いっぱいいっぱいにコンテンツが表示されるようになります。
        </p>
        <p className="p-indent">
          version 1.1.1
        </p>
        <p className="p-indent">
          再生履歴の対象ファイルが削除・移動されていた場合、再生しようとするとクラッシュする問題に対応しました。
        </p>
      </div>
    </>;
}

const showPrivacyPolicy = ver => {
  return <>
          <div className='privacyPolicy'>
            <h1 className='h-margin'>プライバシーポリシー</h1>
            <p className="p-indent">
              このアプリは、ユーザーの個人情報を収集または保存しません。
            </p>
            <p className="p-indent">
              アプリ内で再生する動画ファイルはユーザーが選択したものであり、外部に送信されることはありません。
            </p>
            <p className="p-indent">
              また、インターネット接続を利用する場合も、利用者の操作に基づいてのみ通信が行われます。
            </p>
            <p className="p-indent">
              アプリの名称・バージョン情報、セッション用の情報以外は送信されません。セッション用情報以外の送信された情報はサーバー上に保存されません。
            </p>
          </div>
        </>;
}

export default RcVidPlayerLight;
